
import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="py-12 px-6 max-w-7xl mx-auto text-center">
      <div className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wider text-orange-400 uppercase bg-orange-400/10 rounded-full border border-orange-400/20">
        Anti-Fluff Career Engineering
      </div>
      <h1 className="text-5xl md:text-7xl font-extrabold mb-6 tracking-tight">
        The <span className="gradient-text">AWS Architect</span> Ascent
      </h1>
      <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed">
        Stop being a ticket-driven engineer. Learn the technical patterns and architectural mental shifts 
        required to move from Associate to Principal Engineer.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <a href="#skill-maps" className="px-8 py-3 bg-orange-500 hover:bg-orange-600 transition-colors rounded-lg font-bold text-white shadow-lg shadow-orange-500/20">
          Explore Roadmaps
        </a>
        <a href="#career-coach" className="px-8 py-3 bg-slate-800 hover:bg-slate-700 transition-colors border border-slate-700 rounded-lg font-bold text-white">
          AI Progression Coach
        </a>
      </div>
    </header>
  );
};

export default Header;
